import React from 'react';
import { TABLET_LANDSCAPE } from 'src/client/constants/mediaQueries';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { faArrowRight, faBars } from '@fortawesome/pro-light-svg-icons';
import { NavbarIcon } from '../styles';

type Props = {
  mobileMenuOpened: boolean;
  toggleMobileMenu: () => void;
};

export const MobileMenuToggle = (props: Props) => {
  const { mobileMenuOpened, toggleMobileMenu } = props;

  return (
    <MobileMenuButton className={cx({ active: mobileMenuOpened })} onClick={toggleMobileMenu}>
      <NavbarIcon icon={mobileMenuOpened ? faArrowRight : faBars} />
    </MobileMenuButton>
  );
};

const MobileMenuButton = styled.div`
  transition: 0.3s color;
  font-size: 20px;
  vertical-align: middle;
  color: ${(props) => props.theme.primary7};
  width: min-content;
  padding: 7px;
  margin-right: -2px;

  @media ${TABLET_LANDSCAPE} {
    .container & {
      padding: 10px;
      margin-right: -10px;
    }
  }

  @media ${TABLET_LANDSCAPE} {
    display: none;
  }
`;
